const STORAGE_KEY = 'c4y.admin.mfa.rememberDevice';

export function readRememberDevicePreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeRememberDevicePreference(remember: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    if (remember) window.sessionStorage.setItem(STORAGE_KEY, '1');
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* private mode / blocked storage */
  }
}
